<template>
  <div>
    <!-- 顶部大图 -->
    <div
      class="top_img"
      :style="{
        'background-image': `url(${contactData.topImage})`
      }"
    >
      <p class="title">{{ topTitle }}</p>
<!--      <p class="subtitle">{{ $t("CONTACT US") }}</p>-->
    </div>

    <!-- Keep In Touch 部分 -->
    <div class="keep_in_touch_section">
      <div class="keep_in_touch_content">
        <div class="keep_in_touch_main">
          <!-- 左侧联系信息 -->
          <div class="contact_info_left">
            <p class="h2">{{ $t("Keep In Touch") }}</p>
            <div class="contact_info_item">
              <div class="icon"><img src="../../static/img/callus_tel_icon.png" alt="Tel"></div>
              <div class="info">
                <p class="h2">{{ $t("Tel") }}</p>
                <p>{{ displayPhone }}</p>
              </div>
            </div>
            <div class="contact_info_item">
              <div class="icon"><img src="../../static/img/callus_email_icon.png" alt="Email"></div>
              <div class="info">
                <p class="h2">{{ $t("Email") }}</p>
                <p>{{ displayEmail }}</p>
              </div>
            </div>
            <div class="contact_info_item">
              <div class="icon"><img src="../../static/img/callus_phone_icon.png" alt="Address"></div>
              <div class="info">
                <p class="h2">{{ $t("Address") }}</p>
                <p>{{ displayAddress }}</p>
              </div>
            </div>
          </div>
          <!-- 右侧地图 -->
          <div class="contact_map">
            <div v-if="contactData.mapImageCn" class="map_image">
              <img :src="displayMap" alt="Map">
            </div>
            <div v-else class="map_placeholder">
              <i class="el-icon-map-location"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- We'd Love To Hear From You 表单部分 -->
    <div class="contact_form_section">
      <div class="contact_form_content">
        <p class="h2">{{ $t("We'd Love To Hear From You") }}</p>
        <div class="title_divider"></div>
        <el-form :label-position="top" :model="form" class="contact_form" label-position="top">
          <div class="form_row">
            <el-form-item :label="$t('Last Name')" class="form_col" required>
              <el-input v-model="form.lastName" :placeholder="$t('Last Name')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('First Name')" class="form_col" required>
              <el-input v-model="form.firstName" :placeholder="$t('First Name')"></el-input>
            </el-form-item>
          </div>
          <div class="form_row">
            <el-form-item :label="$t('Telephone')" class="form_col" required>
              <el-input v-model="form.phone" :placeholder="$t('Telephone')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Email')" class="form_col" required>
              <el-input v-model="form.email" :placeholder="$t('Email')"></el-input>
            </el-form-item>
          </div>
          <div class="form_row">
            <el-form-item :label="$t('Country')" class="form_col" required>
              <el-input v-model="form.country" :placeholder="$t('Country')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Address')" class="form_col">
              <el-input v-model="form.address" :placeholder="$t('Address')"></el-input>
            </el-form-item>
          </div>
          <div class="form_row_single">
            <el-form-item :label="$t('Additional Information')" class="form_col" required>
              <el-input
                type="textarea"
                :rows="4"
                v-model="form.message"
                :placeholder="$t('Additional Information')"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item class="submit-btn-item">
            <el-button type="primary" @click="submitForm">{{ $t("Submit") }} ></el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/index";

export default {
  data() {
    return {
      form: {
        lastName: "",
        firstName: "",
        phone: "",
        email: "",
        country: "",
        address: "",
        message: "",
      },
      isMiniWindows: false,
      clientWidth: 0,
      contactData: {
        phoneCn: "",
        phoneEn: "",
        phoneEs: "",
        emailCn: "",
        emailEn: "",
        emailEs: "",
        addressCn: "",
        addressEn: "",
        addressEs: "",
        mapImageCn: "",
        mapImageEn: "",
        mapImageEs: "",
        topImage: "",
        topTitleCn: "",
        topTitleEn: "",
        topTitleEs: ""
      }
    };
  },
  computed: {
    topTitle() {
      return this.$getI18nField(this.contactData, 'topTitle') || this.$t("联系我们");
    },
    displayPhone() {
      return this.$getI18nField(this.contactData, "phone");
    },
    displayEmail() {
      return this.$getI18nField(this.contactData, "email");
    },
    displayAddress() {
      return this.$getI18nField(this.contactData, "address");
    },
    displayMap() {
      return this.$getI18nField(this.contactData, "mapImage");
    }
  },
  watch: {
    clientWidth(newVal) {
      this.isMiniWindows = newVal < 1200;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getContactUsData();
    let that = this;
    var clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
          document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },
  methods: {
    // 获取联系我们信息
    getContactUsData() {
      API.getContactUsList({ page: 1, limit: 1 })
        .then((res) => {
          if (res.code === 0 && res.page && res.page.list && res.page.list.length > 0) {
            const data = res.page.list[0];
            this.contactData = {
              phoneCn: data.phoneCn || "",
              phoneEn: data.phoneEn || "",
              phoneEs: data.phoneEs || "",
              emailCn: data.emailCn || "",
              emailEn: data.emailEn || "",
              emailEs: data.emailEs || "",
              addressCn: data.addressCn || "",
              addressEn: data.addressEn || "",
              addressEs: data.addressEs || "",
              mapImageCn: data.mapImageCn || "",
              mapImageEn: data.mapImageEn || "",
              mapImageEs: data.mapImageEs || "",
              topImage: data.topImage || "",
              topTitleCn: data.topTitleCn || "",
              topTitleEn: data.topTitleEn || "",
              topTitleEs: data.topTitleEs || ""
            };
          }
        })
        .catch(() => {});
    },
    submitForm() {
      // 提交留言
      const data = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        phone: this.form.phone,
        email: this.form.email,
        country: this.form.country,
        address: this.form.address,
        content: this.form.message
      };

      API.createMessage(data)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success(this.$t("提交成功，我们会尽快与您联系！"));
            this.form = {
              lastName: "",
              firstName: "",
              phone: "",
              email: "",
              country: "",
              address: "",
              message: "",
            };
          }
        })
        .catch(() => {
          this.$message.error(this.$t("提交失败，请稍后重试"));
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.top_img {
  padding:0 12.5%;
  height: 47rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .title {
    text-align: left;
    font-size: 7rem;
    font-family: bold;
    color: white;
    margin: 7rem 0 0 0;
    align-self: flex-start;
  }

  .subtitle {
    text-align: left;
    font-size: 2rem;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 1rem;
    letter-spacing: 1rem;
  }
}

// Keep In Touch 部分
.keep_in_touch_section {
  padding: 17.6rem 12.5%;
  background: white;

  .keep_in_touch_content {
    margin: 0 auto;

    .h2 {
      text-align: left;
      font-size: 5rem;
      color: #212121;
      margin-bottom: 9rem;
      margin-top: 0;
      font-family: bold;
    }

    .keep_in_touch_main {
      display: flex;
      gap: 6rem;
      align-items: flex-start;

      .contact_info_left {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6rem;

        .contact_info_item {
          display: flex;
          align-items: flex-start;
          gap: 2rem;

          .icon {
            width: 5rem;
            height: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            i {
              font-size: 2.2rem;
              color: white;
            }
          }

          .info {
            flex: 1;

            .h3 {
              font-family: bold;
              font-size: 2.2rem;
              color: #212121;
              margin-bottom: 0.8rem;
              text-align: left;
              margin-top: 0;
            }

            p {
              text-align: left;
              font-size: 2.2rem;
              color: #5B6370;
              line-height: 1.6;
              margin: 0;
              font-family: regular;
            }
          }
        }
      }

      .contact_map {
        width: 57.8%;
        height: 54rem;

        .map_image {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 1.6rem;
          }
        }

        .map_placeholder {
          width: 100%;
          height: 100%;
          background: white;
          border: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            font-size: 6rem;
            color: #ccc;
          }
        }
      }
    }
  }
}

// 表单部分
.contact_form_section {
  padding: 8rem 12.5%;

  .contact_form_content {
    margin: 0 auto;

    .h2 {
      font-family: bold;
      text-align: left;
      font-size: 3.8rem;
      color: #212121;
      margin-bottom: 3rem;
      margin-top: 0;
    }

    .title_divider {
      width: 8rem;
      height: 0.8rem;
      background-color: #1D2087;
      margin-bottom: 3rem;
    }

    .contact_form {
      .form_row {
        display: flex;
        gap: 5rem;
        margin-bottom: 2rem;

        .form_col {
          flex: 1;
        }
      }

      .form_row_single {
        margin-bottom: 3rem;
      }

      .el-form-item {
        margin-bottom: 0;
      }

      .submit-btn-item {
        /deep/ .el-form-item__content {
          margin-left: 0 !important;
          text-align: left;
        }

        /deep/ .el-button--primary {
          color: #9CCF86;
          border-color: #9CCF86;
          text-align: left;
          font-family: medium;
          font-size: 2rem;
          padding:1rem 3rem 0.5rem;
        }
      }

      .form_col {
        /deep/ .el-form-item__label {
          font-family: medium;
          font-size: 2.2rem;
          color: #212121;
          line-height: 3.1rem;
          padding: 0 0 2.5rem 0;
          text-align: left;
          float: left;
        }

        /deep/ .el-form-item__label::after {
          content: '';
        }
      }

      /deep/ .el-form-item__label {
        text-align: left;
        float: left;
      }

      /deep/ .el-form-item__label {
        &::after {
          content: none;
        }
      }

      /deep/ .el-form-item.is-required > .el-form-item__label::before {
        display: none;
      }

      /deep/ .el-form-item.is-required > .el-form-item__label::after {
        content: '*';
        color: #9CCF86;
        margin-left: 0.3rem;
      }

      /deep/ .el-input__inner,
      /deep/ .el-textarea__inner {
        font-family: light;
        font-size: 2rem;
        padding: 1.5rem 2rem;
        border-radius: 1.6rem;
        border: 1px solid #e0e0e0;
        background: #F5F5F5;
        color: #212121;

        &::placeholder {
          font-family: light;
          color: #BDC0C5;
          font-size: 2rem;
        }

        &:focus {
          border-color: $textBlueColor;
        }
      }

      /deep/ .el-textarea__inner {
        min-height: 12rem;
      }

      /deep/ .el-button {
        padding: 1rem 3rem;
        font-size: 1.6rem;
        background: transparent;
        border: 2px solid #9CCF86;;
        color: #9CCF86;;
        border-radius: 3rem;
        transition: all 0.3s;

        &:hover {
          background: #9CCF86;;
          color: white;
        }
      }
    }
  }
}

// 底部联系信息
.bottom_contact_section {
  padding: 8rem 0;
  background: linear-gradient(135deg, #1a4d8f 0%, #2563a8 100%);

  .bottom_contact_content {
    max-width: 140rem;
    margin: 0 auto;
    padding: 0 2rem;

    .h2 {
      font-size: 3.6rem;
      color: white;
      margin-bottom: 4rem;
    }

    .bottom_contact_card {
      background: white;
      border-radius: 1rem;
      padding: 4rem;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .contact_item {
        display: flex;
        align-items: center;
        gap: 2rem;

        i {
          font-size: 3rem;
          color: $textBlueColor;
        }

        .label {
          font-size: 1.3rem;
          color: #999;
          margin: 0 0 0.5rem 0;
          text-transform: uppercase;
          letter-spacing: 0.1rem;
        }

        .value {
          font-size: 1.6rem;
          color: $color2C;
          margin: 0;
          font-weight: 500;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .top_img {
    height: 30rem;
    padding:0 2rem;

    .title {
      font-size: 3.5rem;
    }

    .subtitle {
      font-size: 1.4rem;
      letter-spacing: 0.5rem;
    }
  }

  .keep_in_touch_section {
    padding: 3rem 2rem;

    .keep_in_touch_content {
      .h2 {
        font-size: 2.8rem;
        margin-bottom: 3rem;
      }

      .keep_in_touch_main {
        flex-direction: column;
        gap: 4rem;

        .contact_map {
          min-height: 30rem;
        }
      }
    }
  }

  .contact_form_section {
    padding: 4rem 0;

    .contact_form_content {
      .h2 {
        font-size: 2.8rem;
        margin-bottom: 3rem;
      }

      .contact_form {
        .form_row {
          flex-direction: column;
          gap: 0;
        }
      }
    }
  }

  .bottom_contact_section {
    padding: 4rem 0;

    .bottom_contact_content {
      .h2 {
        font-size: 2.8rem;
      }

      .bottom_contact_card {
        flex-direction: column;
        gap: 3rem;
        align-items: flex-start;
      }
    }
  }
}

@media (max-width: 768px) {
  .top_img {
    padding: 0 2rem;
    display: flex;

    .title {
      font-size: 3rem;
      margin: 5rem 0 0 0;
    }

    .subtitle {
      font-size: 1.2rem;
      margin-top: 0.5rem;
    }
  }

  .keep_in_touch_section {
    padding: 3rem 2rem;

    .keep_in_touch_content {
      margin: 0;
    }

    .keep_in_touch_main {
      display: flex;
      gap: 3rem;

      .contact_info_left {
        display: flex;

        .contact_info_item {
          display: flex;
          gap: 1.5rem;

          .info {
            .h3 {
              font-size: 1.8rem !important;
              margin-bottom: 0 !important;
              margin-top: 0;
            }

            p {
              font-size: 1.6rem !important;
              margin: 0 !important;
            }
          }
        }
      }

      .contact_map {
        width: 100% !important;
        height: auto !important;
        .map_placeholder {
          display: flex;
        }
      }
    }
  }

  .contact_form_section {
    padding: 3rem 2rem;

    .contact_form_content {
      margin: 0;

      .h2 {
        font-size: 2.5rem;
        margin-bottom: 2rem;
        margin-top: 0;
      }

      .title_divider {
        width: 5rem;
        margin-bottom: 2rem;
      }

      .contact_form {
        .form_row {
          display: flex;
          gap: 0;
          margin-bottom: 1.5rem;
        }

        .form_row_single {
          margin-bottom: 2rem;
        }

        .form_col {
          /deep/ .el-form-item__label {
            font-size: 1.6rem;
            font-family: medium;
            padding: 0;
          }
        }

        /deep/ .el-input__inner,
        /deep/ .el-textarea__inner {
          font-size: 1.6rem;
          padding: 1.2rem 1.5rem;
          border-radius: 0.6rem;
        }

        .submit-btn-item {
          /deep/ .el-button--primary {
            font-size: 1.6rem;
            padding: 0.8rem 2.5rem 0.4rem;
          }
        }
      }
    }
  }

  .keep_in_touch_section {
    .keep_in_touch_content {
      .h2{
        font-size:3rem;
        margin-bottom: 7rem;
      }
      .keep_in_touch_main {
        .contact_info_left {
          gap:3rem;
          .contact_info_item {
            align-items: center;
            text-align: center;
            .icon{
              width: 4rem;
              height: 4rem;
            }
          }
        }
      }
    }
  }

  .bottom_contact_section {
    .bottom_contact_content {
      .bottom_contact_card {
        padding: 2rem;

        .contact_item {
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
      }
    }
  }
}
</style>
